import cx from 'classnames';
import { Spin } from 'grab-ui';
import PropTypes, { bool, node } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  enableAnytimeBookingUIBookingSelector,
  expressPaxHomeV2AnnouncementBannerDataSelector,
  geMaintenanceBannerDataSelector,
  maintenanceBannerDismissedSelector,
} from 'selectors/app-selector';
import { globalLoadingSelector } from 'selectors/common-selector';
import supportsWebP from 'supports-webp';
import { shouldShowBanner } from '../notice-banner/banner-utils';
import css from './app-layout.less';

const BACKGROUND_HEIGHT_WITH_BANNER = 300;
const BACKGROUND_HEIGHT_WITH_ANYTIME_BOOKING = 226;
const BACKGROUND_HEIGHT_NORMAL = 287;

const AppLayout = ({
  children,
  globalLoading,
  enableAnytimeBookingUIBooking,
  expressPaxHomeV2AnnouncementBannerData,
  geMaintenanceBannerData,
  maintenanceBannerDismissed,
}) => {
  const [showWebp, setShowWebp] = useState(true);

  useEffect(() => {
    supportsWebP
      .then(isSupported => {
        setShowWebp(isSupported);
      })
      .catch(() => {
        setShowWebp(false);
      });
  }, []);

  const getBackgroundHeight = () => {
    if (
      shouldShowBanner(
        expressPaxHomeV2AnnouncementBannerData,
        geMaintenanceBannerData,
        maintenanceBannerDismissed,
      )
    ) {
      return BACKGROUND_HEIGHT_WITH_BANNER;
    }

    if (
      enableAnytimeBookingUIBooking &&
      window.location.pathname.indexOf('/shopify') === -1
    ) {
      return BACKGROUND_HEIGHT_WITH_ANYTIME_BOOKING;
    }

    return BACKGROUND_HEIGHT_NORMAL;
  };

  return (
    <div className={css.rootLayout} id="root-layout">
      {globalLoading && (
        <div className={css.globalLoading}>
          <Spin size={'large'} />
        </div>
      )}
      <div
        className={cx(css.backgroundImage, {
          [css.backgroundImageWebP]: showWebp,
          [css.backgroundImagePng]: !showWebp,
        })}
        style={{
          height: `${getBackgroundHeight()}px`,
        }}
      />
      <div className={css.layout}>{children}</div>
    </div>
  );
};

AppLayout.propTypes = {
  children: node.isRequired,
  globalLoading: bool,
  expressPaxHomeV2AnnouncementBannerData: PropTypes.arrayOf(
    PropTypes.shape({}),
  ),
  geMaintenanceBannerData: PropTypes.shape({}),
  enableAnytimeBookingUIBooking: bool,
  maintenanceBannerDismissed: bool,
};

AppLayout.defaultProps = {
  globalLoading: false,
  expressPaxHomeV2AnnouncementBannerData: [],
  geMaintenanceBannerData: null,
  enableAnytimeBookingUIBooking: false,
  maintenanceBannerDismissed: false,
};

export default connect(state => ({
  enableAnytimeBookingUIBooking: enableAnytimeBookingUIBookingSelector(state),
  maintenanceBannerDismissed: maintenanceBannerDismissedSelector(state),
  expressPaxHomeV2AnnouncementBannerData: expressPaxHomeV2AnnouncementBannerDataSelector(
    state,
  ),
  geMaintenanceBannerData: geMaintenanceBannerDataSelector(state),
  globalLoading: globalLoadingSelector(state),
}))(AppLayout);
